// extracted by mini-css-extract-plugin
module.exports = {"info":"ChallengeInfo_info__2qYao","item":"ChallengeInfo_item__18xoB","text":"ChallengeInfo_text__veNjt","divider":"ChallengeInfo_divider__1o4YQ"};